import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import { experience } from "../data/experience";
import ExperienceCard from "./ExperienceCard";

const Experience: React.FC = () => {
  return (
    <section id="experience" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Experience
        </motion.h2>
        <div className="mt-6 space-y-4">
          {experience.map((exp, i) => (
            <ExperienceCard experience={exp} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Experience;
